module.exports = __webpack_public_path__ + "static/img/图层63.1522ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层63.png
// module id = pKvo
// module chunks = 0